import modalConfirmation from '../../shared/components/modal-response/modal-response.view.html';
let inject = [
  '$scope',
  'PayZoneDashboardService',
  '$state',
  '$rootScope',
  'SharedService',
  '$uibModal'
];

class PayZoneDashboardController{
  constructor ($scope, PayZoneDashboardService, $state, $rootScope, SharedService, $uibModal) {
    this.$state = $state;
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$uibModal = $uibModal;
    this.PayZoneDashboardService = PayZoneDashboardService;
    this.SharedService = SharedService;
    this.loanding = false;
    this.plants = [];
    this.billfoldResume = null;
    this.billfoldResumeAll = null;
    this.loadingBillResume = false;
  }

  $onInit(){
    this.getPlants();
  }
  
  getPlants() {
    this.PayZoneDashboardService.getPlants(this.shCtrl.globals.currentUser.thirdDocumentNumber).then(response => {
      this.plants = response;
      this.billfoldResumeAll = 0;
      response.forEach((val, index) => {
        if(angular.isString(val.cartera)) val.cartera = parseInt(val.cartera);
        this.billfoldResumeAll += val.cartera;
      });
      let thirdDocumentNumber = this.shCtrl.globals.currentClient.third.documentNumber;
      let branchCode = this.shCtrl.globals.currentClient.operatingCenter.code;
      this.PayZoneDashboardService.getBillFold(thirdDocumentNumber, branchCode).then(billfoldResume => {
        this.loadingBillResume = false;
        this.billfoldResume = billfoldResume;
      }).catch(error => {
        this.loadingBillResume = false;
      });
    }).catch(reason => {
    
    });
  }

  messageResponse (options, callAcept, callback, callCancel, callbackCancel) {
    let modalInstance = this.$uibModal.open({
      animation: true,
      template: modalConfirmation,
      controller : 'ModalResponseController',
      controllerAs : 'mdCtrl',
      size: options.size,
      resolve : {
        modalOptions : () => options
      }
    });
    modalInstance.result.then(() => {
      if(callAcept) {
        callback();
      }
    }).catch(reason => {
      if(callCancel) {
        callbackCancel();
      }
    });
  }
}

PayZoneDashboardController.$inject = inject;

export default PayZoneDashboardController;




/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/pay-zone/dashboard/dashboard.controller.js
 **/